import { Flex, useMediaQuery } from '@podiumhq/design-system';

import { BusinessNameField } from 'components/BusinessDetails';
import { useTrialsContext } from 'contexts/TrialsContextProvider';
import { MEDIUM_MEDIA_QUERY_WIDTH } from 'styles';

import EmailField from '../../components/FormFields/EmailField';
import MobileField from '../../components/FormFields/MobileField';
import NameField from '../../components/FormFields/NameField';
import { TrialButtonWithLoading, TrialDisclaimer } from '../../layout';
import { multiStepInputStyles } from '../../styles';

const TrialAccountSection = ({ buttonLabel, handleSubmit, isSubmitting }) => {
  const [isSmallerThan850px] = useMediaQuery(
    `(max-width: ${MEDIUM_MEDIA_QUERY_WIDTH}px)`
  );
  const { firstName, lastName, setFirstName, setLastName } =
    useTrialsContext() || {};

  const onButtonClick = () => {
    if (handleSubmit) {
      handleSubmit();
    }
  };

  const trialNameInputWrapperStyles = {
    direction: isSmallerThan850px ? 'column' : 'row',
    justify: isSmallerThan850px ? 'start' : 'space-between',
    sx: {
      '> div': { width: isSmallerThan850px ? '100%' : 'calc(50% - 8px)' },
    },
  };

  const trialNameInputCommonProps = {
    disabled: isSubmitting,
    placeholder: null,
    trackingEventName: 'accountInfo',
    ...multiStepInputStyles,
  };

  return (
    <>
      <Flex {...trialNameInputWrapperStyles}>
        <NameField
          fieldName="firstName"
          label="First Name"
          setFieldValue={setFirstName}
          value={firstName}
          {...trialNameInputCommonProps}
        />
        <NameField
          fieldName="lastName"
          label="Last Name"
          setFieldValue={setLastName}
          value={lastName}
          {...trialNameInputCommonProps}
        />
      </Flex>

      <EmailField
        label="Email"
        listenForIframeEmailMessage={false}
        {...trialNameInputCommonProps}
      />

      <MobileField label="Mobile Number" {...trialNameInputCommonProps} />

      <BusinessNameField
        boxWrapperProps={{ mb: '24px' }}
        label="Business Name"
        {...trialNameInputCommonProps}
      />

      <TrialDisclaimer
        color="grey.base"
        disclaimerText="By continuing, you’re agreeing to Podium"
        fontSize="14px"
        linkProps={{
          color: 'blue.base',
          textDecoration: 'none',
          sx: { _hover: { textDecoration: 'none' } },
        }}
      />

      <TrialButtonWithLoading
        data-testid="TrialAccountButton-submit-btn"
        buttonLabel={buttonLabel}
        id="trial-account-button"
        isLoading={isSubmitting}
        onClick={onButtonClick}
        width="100%"
      />
    </>
  );
};

export default TrialAccountSection;
